// extracted by mini-css-extract-plugin
export default {"header":"header---ynqPZ","positive":"positive---gEh2M","headerStart":"headerStart---BqAIE"};